<template>
  <div @click="$emit('navigate', node.id)">
    <GraphlyD3
      ref="graphly"
      :dark="darkTheme"
      :env-gravity="0"
      style="width: 130px; height: 130px"
      @node-click="$emit('navigate', node.id)"
    />
  </div>  
</template>

<script setup lang="ts">
import { onMounted, ref} from "vue";
import "@livereader/graphly-d3/style.css";
import GraphlyD3 from "@livereader/graphly-d3/component/vue3";

const compProps = defineProps<{
	node: any;
}>();
defineEmits(["navigate"]);

const graphly = ref<any>(null);
const darkTheme = ref(false);
const graph = ref<{nodes:Array<any>, links: Array<any>}>({ nodes:[compProps.node], links: []})

onMounted(() => {
  graphly.value.simulation.render(graph.value, 0);
  graphly.value.simulation.moveTo({
		nodes: graph.value.nodes,
		padding: 10,
	});
})
</script>